<div
  class="not-found"
  *transloco="let t">
  <h1 class="not-found_title">{{ t('not-found.message') }}</h1>
  <p class="not-found_description">
    <a
      class="link"
      href="{{ loginLink | async }}"
      *ngIf="!isLoggedIn"
      >{{ t('not-found.go-to-login') }}</a
    >
    <a
      class="link"
      href="/dashboard/"
      *ngIf="isLoggedIn"
      >{{ t('not-found.go-to-jobs') }}</a
    >
  </p>
</div>
